export function formatImportErrorMessage(responseBody, fallbackMessage = "Import failed") {
  const errorMessage = responseBody?.error || fallbackMessage;

  if (responseBody?.code !== "COLLECTION_LIMIT_EXCEEDED") {
    return errorMessage;
  }

  const details = responseBody?.details || {};
  const collectionLabel = details.collectionLabel || "this collection";
  const limit = Number(details.limit);
  const currentTotal = Number(details.currentTotal);
  const increaseBy = Number(details.increaseBy);

  if (!Number.isFinite(limit) || !Number.isFinite(currentTotal) || !Number.isFinite(increaseBy)) {
    return errorMessage;
  }

  return `Too many cards for ${collectionLabel}. You have ${currentTotal} already, this import adds ${increaseBy}, and your limit is ${limit}.`;
}